import { useLocation } from 'react-router-dom';
import { getBetaProgram } from './programs';
import { extractBetaProgramSlug, toProgramAwarePath } from './routing';

export const useBetaProgram = () => {
  const location = useLocation();
  const programSlug = extractBetaProgramSlug(location.pathname);
  const program = getBetaProgram(programSlug);

  return {
    isBetaMode: Boolean(program),
    program,
    programSlug,
    withProgramPath: (to) => toProgramAwarePath(to, location.pathname)
  };
};
